import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  rootRouteRef,
  agentDetailRouteRef,
  providerAccountsRouteRef,
  providerAccountDetailRouteRef,
} from './routes';
import { aiAgentsApiRef, AiAgentsClient } from './api';

export const aiAgentsPlugin = createPlugin({
  id: 'ai-agents',
  routes: {
    root: rootRouteRef,
    detail: agentDetailRouteRef,
    providerAccounts: providerAccountsRouteRef,
    providerAccountDetail: providerAccountDetailRouteRef,
  },
  apis: [
    createApiFactory({
      api: aiAgentsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiAgentsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const AiAgentsPage = aiAgentsPlugin.provide(
  createRoutableExtension({
    name: 'AiAgentsPage',
    component: () =>
      import('./components/AgentListPage').then(m => m.AgentListPage),
    mountPoint: rootRouteRef,
  }),
);

export const AiAgentDetailPage = aiAgentsPlugin.provide(
  createRoutableExtension({
    name: 'AiAgentDetailPage',
    component: () =>
      import('./components/AgentDetailPage').then(m => m.AgentDetailPage),
    mountPoint: agentDetailRouteRef,
  }),
);

export const ProviderAccountListPage = aiAgentsPlugin.provide(
  createRoutableExtension({
    name: 'ProviderAccountListPage',
    component: () =>
      import('./components/ProviderAccountListPage').then(
        m => m.ProviderAccountListPage,
      ),
    mountPoint: providerAccountsRouteRef,
  }),
);

export const ProviderAccountDetailPage = aiAgentsPlugin.provide(
  createRoutableExtension({
    name: 'ProviderAccountDetailPage',
    component: () =>
      import('./components/ProviderAccountDetailPage').then(
        m => m.ProviderAccountDetailPage,
      ),
    mountPoint: providerAccountDetailRouteRef,
  }),
);
